import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import DynamicForm, { withExtension } from 'components/Shared/DynamicForm'
import ReportTemplateSchema from 'schemas/reportTemplate.schema.json'
import { useAppContext } from 'hooks/useAppContext'
import { updateReportTemplate } from 'utils/ProjectConfigurationUtil'
import { useFormContext } from 'hooks/useFormContext'
import SkeletonForm from 'components/Shared/SkeletonForm'
import { useCanDoAction } from 'hooks/useCanDoAction'

const ReportTemplate = ({ orientation, defaultValues, CRUDType, callback, disabledProperties, hiddenProperties }) => {

    const { selectedProject, selectedProjectData } = useAppContext()
    const formContext = useFormContext()
    const [schamaState, setSchemaState] = React.useState(true)
    const canUpdate = useCanDoAction('ProjectConfig', 'update');
    useEffect(() => {
        schamaState && formContext.updateSchema(ReportTemplateSchema)
        setSchemaState(false)
    }, [schamaState, formContext])

    if (CRUDType === "INSERT") defaultValues['IsActive'] = true && disabledProperties.push('IsActive')

    // contact specific CRUD functions
    const onSubmit = async (values) => {
        let result
        if (CRUDType === "UPDATE") {
            result = await updateReportTemplate(selectedProject, values, defaultValues)
            setTimeout(callback, 1000)
        }

        return result
    }

    return selectedProjectData && formContext.ready ?
        withExtension(DynamicForm, { schema: ReportTemplateSchema, orientation, onSubmit, defaultValues, disabledProperties, 
            hiddenProperties, definitions: formContext.definitions, readOnly: true, readOnlyEdit: canUpdate }) :
        <SkeletonForm />

}



ReportTemplate.propTypes = {
    orientation: PropTypes.string,
    defaultValues: PropTypes.object,
    CRUDType: PropTypes.oneOf(['INSERT', 'UPDATE']).isRequired,
    callback: PropTypes.func,
    disabledProperties: PropTypes.array,
    hiddenProperties: PropTypes.array
}

ReportTemplate.defaultProps = {
    orientation: "Vertical",
    callback: () => { },
    defaultValues: {},
    disabledProperties: [],
    hiddenProperties: []
}




export default ReportTemplate
